import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { UnionIcon } from '@gem/icons';
import { popupItemStyles } from '@gem/ui-kit';

import { AvatarTypes } from 'APP/components/Avatar/Avatar';
import { PopupInfoCard } from 'APP/components/PopupInfoCard/PopupInfoCard';
import { VerifiedBadge } from 'APP/components/VerifiedBadge/VerifiedBadge';
import { User } from 'STORE/Users/User/User';

import { useWorkspaceMemberWithCheckboxPresenter } from './WorkspaceMemberWithCheckbox.presenter';
import styles from './WorkspaceMemberWithCheckbox.style.m.css';

interface IWorkspaceMemberWithCheckboxProps {
  getIsSelected(member: User): boolean;
  toggleMember(member: User): void;
  member: User;
}

export const WorkspaceMemberWithCheckbox: FC<IWorkspaceMemberWithCheckboxProps> = observer(
  ({ getIsSelected, toggleMember, member }) => {
    const { userOnlineStatusText } = useWorkspaceMemberWithCheckboxPresenter(member);

    const classes = classNames(popupItemStyles.container, popupItemStyles.interactive);

    const isSelected = getIsSelected(member);

    const checkboxClass = classNames(styles.checkboxView, {
      [styles.selected]: isSelected,
    });

    return (
      <label className={classes}>
        <PopupInfoCard
          type={AvatarTypes.Round_10}
          className={popupItemStyles.card}
          avatarTitle={member.avatarTitle}
          avatarUrl={member.avatarUrl || undefined}
          avatarBackgroundColorIndex={member.avatarColorIndex}
          title={member.displayName}
          subtitle={userOnlineStatusText}
          badge={member.verified && <VerifiedBadge />}
        />
        <div className={checkboxClass}>
          <input
            type="checkbox"
            className={styles.checkbox}
            onChange={(): void => toggleMember(member)}
            checked={isSelected}
          />
          {isSelected && <UnionIcon />}
        </div>
      </label>
    );
  }
);
